import { useNavigate } from "react-router-dom";

// Img
import heartIcon from "../../../assets/svg/hearticon.svg";
import checkIcon from "../../../assets/svg/round-tick-dark.svg";

// CSS
import classes from "./PriceCard.module.css";

// MUI
import { Card, Divider, Stack, Typography } from "@mui/material";

// Local
import CustomCard from "./CustomCard";
import IconLabel from "../IconLabel";
import Badge from "../Badges/Badge";
import PrimaryButton from "../Buttons/PrimaryButton";
import { Button } from "@jds/core";

const PlanItem = (props) => {
  return (
    <IconLabel
      icon={
        <img
          src={checkIcon}
          alt="dark rounded tick icon"
          style={{ width: "20px" }}
        />
      }
      label={props.label || "label"}
      textVariant="body1"
      {...props}
    />
  );
};

export default function PriceCard(props) {
  const navigate = useNavigate();
  return (
    <CustomCard className={classes["price-card"]} radius="20px" {...props}>
      <div className="price-card__details">
        <Stack
          className={classes["badge-container"]}
          direction="row"
          justifyContent="flex-start"
        >
          {/* <Badge
            bgColor="var(--color-primary-20)"
            color="var(--color-primary-50)"
            label="14 day trial"
          /> */}
          {/* <Badge
            icon={<img src={heartIcon} alt="heart icon" />}
            bgColor={"var(--color-sparkle-50)"}
            label="Recommended"
          /> */}
        </Stack>
        <Stack direction="row" justifyContent="space-between" mb={4}>
          <Typography variant="h2" fontFamily="var(--font-semibold)">
            Free
          </Typography>
          <Typography variant="h2">5GB</Typography>
        </Stack>
        {/* <Stack direction="column" gap="24px">
          <PlanItem label="10 GB" />
          <PlanItem label="5 MB" />
        </Stack> */}
        {/* <Divider variant="dashed" sx={{ m: "40px 8px 32px" }} /> */}
        {/* <div>
          <Typography
            component="span"
            variant="h2"
            fontFamily="var(--font-semibold)"
          >
            ₹800
          </Typography>
          <Typography variant="body1" component="span">
            /month
          </Typography>
        </div> */}
      </div>
      <Stack mt="53px">
        {/* <PrimaryButton size="large">Try now</PrimaryButton> */}
        <Button
          size="large"
          label="Try now"
          fullWidth
          onClick={() => navigate("/auth/signin")}
        />
      </Stack>
    </CustomCard>
  );
}
